import React, { useContext } from 'react'
import { ContentFooter } from '../../layout/Content'
import RecordNavigator from '../../layout/RecordNavigator'
import InvoiceListFooterStyle from './css/InvoiceListFooterStyle'
import { invoiceListControllerContext } from './InvoiceListController'

function InvoiceListFooter() {
  const invoiceListController = useContext(invoiceListControllerContext)
  const { getTotalRecords, totalPage } = invoiceListController
  const [recordPerPage, setRecordPerPage] = invoiceListController.recordPerPage
  const [recPP, setRecPP] = invoiceListController.recPP
  const [page, setPage] = invoiceListController.page

  const recordNavigatorProps = {
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    recordPerPage: [recordPerPage, setRecordPerPage],
    totalPage, getTotalRecords
  }

  return (
    <ContentFooter>
      <div id='invoice-list-footer-container'>
        <RecordNavigator { ...recordNavigatorProps }/>
      </div>
      <InvoiceListFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(InvoiceListFooter)